/**
 * Product card variant thumbs with quantity and add to cart
 */

(function () {
  if (window.__productCardVariantThumbsInitialized) return;
  window.__productCardVariantThumbsInitialized = true;

  const SELECTORS = {
    card: '.m-product-card',
    thumb: '[data-variant-thumb]',
    mainImage: '.m-product-card__main-image-el',
    productLink: '[data-product-card-link]',
    variantInput: '[data-product-variant-input]',
    addToCart: '[data-card-add-to-cart]',
    qtyInput: '[data-qty-input]',
    qtyIncrease: '[data-qty-increase]',
    qtyDecrease: '[data-qty-decrease]'
  };

  function updateThumbState(card, activeThumb) {
    const thumbs = card.querySelectorAll(SELECTORS.thumb);

    thumbs.forEach((thumb) => {
      thumb.classList.remove('is-active');
      thumb.setAttribute('aria-pressed', 'false');
    });

    if (activeThumb) {
      activeThumb.classList.add('is-active');
      activeThumb.setAttribute('aria-pressed', 'true');
    }
  }

  function updateMainImage(card, imageUrl) {
    if (!imageUrl) return;

    const image = card.querySelector(SELECTORS.mainImage);
    if (!image) return;

    image.src = imageUrl;
    image.removeAttribute('srcset');
  }

  function updateProductLink(card, variantUrl) {
    if (!variantUrl) return;

    const link = card.querySelector(SELECTORS.productLink);
    if (!link) return;

    link.setAttribute('href', variantUrl);
  }

  function updateVariantInput(card, variantId) {
    if (!variantId) return;

    const input = card.querySelector(SELECTORS.variantInput);
    if (!input) return;

    input.value = variantId;
    input.setAttribute('value', variantId);
  }

  function updateAddToCartButton(card, variantId, isAvailable) {
    const button = card.querySelector(SELECTORS.addToCart);
    if (!button) return;

    button.dataset.variantId = variantId || '';

    if (isAvailable) {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    } else {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    }
  }

  function applyVariantToCard(card, thumb) {
    if (!card || !thumb) return;

    const variantId = thumb.dataset.variantId || '';
    const variantImage = thumb.dataset.variantImage || '';
    const variantUrl = thumb.dataset.variantUrl || '';
    const variantAvailable = thumb.dataset.variantAvailable === 'true';

    updateThumbState(card, thumb);
    updateMainImage(card, variantImage);
    updateProductLink(card, variantUrl);
    updateVariantInput(card, variantId);
    updateAddToCartButton(card, variantId, variantAvailable);
  }

  function getQuantity(card) {
    const input = card.querySelector(SELECTORS.qtyInput);
    if (!input) return 1;

    const value = parseInt(input.value, 10);

    if (Number.isNaN(value) || value < 1) {
      input.value = 1;
      return 1;
    }

    return value;
  }

  function setQuantity(card, value) {
    const input = card.querySelector(SELECTORS.qtyInput);
    if (!input) return;

    const nextValue = Math.max(1, value);
    input.value = nextValue;
  }

  function updateCartSections(sections) {
    if (!sections) return;

    const sectionMap = {
      'cart-icon-bubble': [
        '#cart-icon-bubble',
        '.m-cart-icon-bubble',
        '[data-cart-count]'
      ],
      'cart-drawer': [
        'cart-drawer',
        '.m-cart-drawer',
        '[data-cart-drawer]'
      ]
    };

    Object.entries(sectionMap).forEach(([sectionId, selectors]) => {
      const htmlString = sections[sectionId];
      if (!htmlString) return;

      const parsed = document.createElement('div');
      parsed.innerHTML = htmlString;

      selectors.forEach((selector) => {
        const currentEl = document.querySelector(selector);
        const newEl = parsed.querySelector(selector);

        if (currentEl && newEl) {
          currentEl.innerHTML = newEl.innerHTML;
        }
      });
    });
  }

  
  function openMiniCart() {
  const cartToggle =
    document.querySelector('[data-cart-drawer-trigger]') ||
    document.querySelector('.m-cart-drawer-button') ||
    document.querySelector('.m-header__cart') ||
    document.querySelector('[href="#cart-drawer"]') ||
    document.querySelector('[href="/cart"]');

  if (cartToggle && typeof cartToggle.click === 'function') {
    cartToggle.click();
    return;
  }

  const cartDrawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('.m-cart-drawer') ||
    document.querySelector('[data-cart-drawer]');

  if (cartDrawer) {
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('open', 'true');
    cartDrawer.removeAttribute('aria-hidden');
  }

  document.dispatchEvent(
    new CustomEvent('cart:open', {
      bubbles: true
    })
  );

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:open', {
      bubbles: true
    })
  );
}

 async function handleAddToCart(card, button) {
  if (!card || !button) return;
  if (button.dataset.loading === 'true') return;

  const variantInput = card.querySelector(SELECTORS.variantInput);
  const variantId = variantInput?.value || button.dataset.variantId || '';
  const quantityInput = card.querySelector(SELECTORS.qtyInput);
  const quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value || '1', 10)) : 1;

  if (!variantId) {
    console.error('Add to cart error: Missing variant ID.');
    return;
  }

  button.dataset.loading = 'true';
  button.disabled = true;
  button.classList.add('is-loading');

  try {
    const sections = ['cart-drawer', 'cart-icon-bubble'];

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: Number(quantity)
          }
        ],
        sections,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Cart add error response:', data);
      throw new Error(data?.description || data?.message || 'Failed to add variant to cart.');
    }

    if (data.sections) {
      updateCartSections(data.sections);
    }

    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    const cart = await cartResponse.json();

    updateCartCountBubble(cart);
    openMiniCart();

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart }
      })
    );

    if (quantityInput) {
      quantityInput.value = 1;
    }

    button.classList.remove('is-loading');
    button.disabled = false;
    button.dataset.loading = 'false';
  } catch (error) {
    console.error('Add to cart error:', error);
    button.classList.remove('is-loading');
    button.disabled = false;
    button.dataset.loading = 'false';
  }
}

  function onDocumentClick(event) {
    const thumb = event.target.closest(SELECTORS.thumb);

    if (thumb) {
      const card = thumb.closest(SELECTORS.card);
      if (!card) return;

      event.preventDefault();
      applyVariantToCard(card, thumb);
      return;
    }

    const qtyIncrease = event.target.closest(SELECTORS.qtyIncrease);
    if (qtyIncrease) {
      const card = qtyIncrease.closest(SELECTORS.card);
      if (!card) return;

      event.preventDefault();
      const currentQty = getQuantity(card);
      setQuantity(card, currentQty + 1);
      return;
    }

    const qtyDecrease = event.target.closest(SELECTORS.qtyDecrease);
    if (qtyDecrease) {
      const card = qtyDecrease.closest(SELECTORS.card);
      if (!card) return;

      event.preventDefault();
      const currentQty = getQuantity(card);
      setQuantity(card, currentQty - 1);
      return;
    }

    const addToCartButton = event.target.closest(SELECTORS.addToCart);
    if (addToCartButton) {
      const card = addToCartButton.closest(SELECTORS.card);
      if (!card) return;

      event.preventDefault();
      handleAddToCart(card, addToCartButton);
    }
  }

  function onDocumentKeydown(event) {
    const thumb = event.target.closest(SELECTORS.thumb);
    if (!thumb) return;

    if (event.key !== 'Enter' && event.key !== ' ') return;

    const card = thumb.closest(SELECTORS.card);
    if (!card) return;

    event.preventDefault();
    applyVariantToCard(card, thumb);
  }

  function initCards(root = document) {
    const cards = root.querySelectorAll(SELECTORS.card);

    cards.forEach((card) => {
      if (card.dataset.variantThumbsReady === 'true') return;

      const activeThumb = card.querySelector(`${SELECTORS.thumb}.is-active`);
      const firstThumb = card.querySelector(SELECTORS.thumb);
      const thumbToApply = activeThumb || firstThumb;

      if (thumbToApply) {
        applyVariantToCard(card, thumbToApply);
      }

      const qtyInput = card.querySelector(SELECTORS.qtyInput);
      if (qtyInput && (!qtyInput.value || Number(qtyInput.value) < 1)) {
        qtyInput.value = 1;
      }

      card.dataset.variantThumbsReady = 'true';
    });
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onDocumentKeydown);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCards(document);
    });
  } else {
    initCards(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCards(event.target);
  });

  function updateCartCountBubble(cart) {
  if (!cart || typeof cart.item_count === 'undefined') return;

  const count = cart.item_count;

  const selectors = [
    '#cart-icon-bubble',
    '.m-cart-icon-bubble',
    '[data-cart-count]',
    '.m-cart-count-bubble',
    '.m-cart-count'
  ];

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.matches('[data-cart-count], .m-cart-count')) {
        el.textContent = count;
        return;
      }

      const countEl =
        el.querySelector('[data-cart-count]') ||
        el.querySelector('.m-cart-count') ||
        el.querySelector('.count') ||
        el.querySelector('.m-count');

      if (countEl) {
        countEl.textContent = count;
      } else {
        el.textContent = count;
      }

      if (count > 0) {
        el.classList.remove('hidden');
        el.classList.remove('is-hidden');
      }
    });
  });
}

document.addEventListener('click', function (event) {
  var thumb = event.target.closest('[data-variant-thumb]');

  document.querySelectorAll('[data-variant-thumb].is-tooltip-open').forEach(function (item) {
    if (item !== thumb) {
      item.classList.remove('is-tooltip-open');
    }
  });

  if (!thumb) return;

  if (window.matchMedia('(hover: none)').matches) {
    thumb.classList.add('is-tooltip-open');

    window.clearTimeout(thumb.__variantTooltipTimer);
    thumb.__variantTooltipTimer = window.setTimeout(function () {
      thumb.classList.remove('is-tooltip-open');
    }, 1800);
  }
});
})();

